import logo from './logo.svg';
import './App.css';
import './index.css'
// import "bootstrap/dist/css/bootstrap.min.css";
import FileUpload from './Components/FirstScreen';
import FileComponent from './Components/Screen1'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Subdirectory from './Components/Subdirectory';
import Login from './Components/Login';
import { Navigate, Outlet } from "react-router-dom";
function App() {

  const PrivateRoute = () => {
    const token = localStorage.getItem("authTokenforEIF");
    return token ? <Outlet /> : <Navigate to="/" />;
  };
  return (
 
    <div className="App">
      <Router>
        <Routes>

          <Route path='/' element={<Login></Login>}></Route>
          <Route element={<PrivateRoute />}>
          <Route path='/allfolders' element={<FileUpload></FileUpload>}></Route>
          <Route path='/files' element={<FileComponent></FileComponent>}></Route>
          <Route path='/sub' element={<Subdirectory></Subdirectory>}></Route>
          </Route>
        </Routes>
      </Router>
   
    </div>
  )
}



export default App;








